export default __webpack_public_path__ + "static/media/11.16.9f04e347.jpg";